import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { objectivesApi } from '../api/objectives.api'
import type { CreateObjectiveFormData, UpdateObjectiveData } from '../types'

const OBJECTIVES_KEY = ['objectives'] as const

export function useObjectives() {
  return useQuery({
    queryKey: OBJECTIVES_KEY,
    queryFn: () => objectivesApi.fetchAll().then((r) => r.data.data),
  })
}

export function useCreateObjective() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateObjectiveFormData) =>
      objectivesApi.create(data).then((r) => r.data.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: OBJECTIVES_KEY }),
  })
}

export function useUpdateObjective() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateObjectiveData }) =>
      objectivesApi.update(id, data).then((r) => r.data.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: OBJECTIVES_KEY }),
  })
}
